<template>
  <div class="leaderboard-one-fifty">
    <ins class="leaderboard__ad adsbygoogle leaderboard" data-ad-client="ca-pub-2580109990739065" data-ad-slot="4200499317"></ins>
  </div>
</template>

<script>
  export default {
    props: {
      wait: {
        type: Boolean,
        default: false
      },
      topMargin: {
        type: Boolean,
        default: false
      },
      bottomMargin: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      record: {}
    }),
    mounted () {
      // fetch ad from api
      // if no result, display google - delayed
      // if (!this.wait) {
      setTimeout((window.adsbygoogle = window.adsbygoogle || []).push({}), 500)
      // }
    }
  }
</script>

<style>
  .leaderboard-one-fifty {
    margin: 2rem auto 0 auto;
    width: 288px!important;
    height: 288px;
    max-width: 288px!important;
    overflow: hidden;
  }

  .leaderboard__ad {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/LeaderBoardOneFifty.vue